import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypePptxIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#CD8923"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#8A6123"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M13.3427 16.3389V19.8501C13.3426 20.0568 13.5105 20.2247 13.7171 20.2247C13.9239 20.2247 14.0917 20.0568 14.0917 19.8501V16.3389C14.0917 16.1322 13.9239 15.9644 13.7171 15.9644C13.5105 15.9644 13.3426 16.1322 13.3427 16.3389Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.1217 15.7303H12.3127C12.1061 15.7303 11.9381 15.8981 11.9382 16.1048C11.9382 16.3115 12.1061 16.4793 12.3127 16.4793H15.1217C15.3284 16.4793 15.4963 16.3115 15.4963 16.1048C15.4963 15.8981 15.3284 15.7303 15.1217 15.7303Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M4.7284 18.5861H6.3631C7.01164 18.5861 7.53739 18.0604 7.53739 17.4118V16.9046C7.53739 16.256 7.01164 15.7303 6.3631 15.7303C5.53281 15.7303 4.35393 15.7303 4.35393 15.7303C4.14701 15.7303 3.97937 15.8979 3.97937 16.1048V19.8501C3.97937 20.0568 4.14719 20.2247 4.35393 20.2247C4.56058 20.2247 4.7284 20.0568 4.7284 19.8501V18.5861ZM4.7284 17.837H6.3631C6.59798 17.837 6.78836 17.6467 6.78836 17.4118V16.9046C6.78836 16.6697 6.59798 16.4793 6.3631 16.4793H4.7284V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.84825 18.5861H10.4829C11.1314 18.5861 11.6571 18.0604 11.6572 17.4118V16.9046C11.6571 16.256 11.1314 15.7303 10.4829 15.7303C9.65256 15.7303 8.47368 15.7303 8.47368 15.7303C8.26685 15.7303 8.09912 15.8979 8.09912 16.1048V19.8501C8.09912 20.0568 8.26694 20.2247 8.47368 20.2247C8.68034 20.2247 8.84825 20.0568 8.84825 19.8501V18.5861ZM8.84825 17.837H10.4829C10.7177 17.837 10.9081 17.6467 10.9081 17.4118V16.9046C10.9081 16.6697 10.7177 16.4793 10.4829 16.4793H8.84825V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.6209 20.0967L19.898 16.3514C20.0341 16.1959 20.0183 15.959 19.8627 15.8229C19.7071 15.6869 19.4704 15.7026 19.3342 15.8582L16.0571 19.6035C15.921 19.759 15.9367 19.9959 16.0923 20.132C16.2479 20.2681 16.4847 20.2523 16.6209 20.0967Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M19.898 19.6035L16.6209 15.8582C16.4847 15.7026 16.2479 15.6869 16.0923 15.8229C15.9367 15.959 15.921 16.1959 16.0571 16.3514L19.3342 20.0967C19.4704 20.2523 19.7071 20.2681 19.8627 20.132C20.0183 19.9959 20.0341 19.759 19.898 19.6035Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M11.6105 4.51202C9.62745 4.7007 8.0741 6.37297 8.0741 8.40524C8.0741 10.5637 9.82646 12.3162 11.9849 12.3162C13.0568 12.3162 14.0286 11.884 14.7352 11.1847L11.7452 8.69297C11.6598 8.62178 11.6105 8.51634 11.6105 8.40524V4.51202ZM12.3595 4.51202V8.22978L15.2151 10.6095C15.6445 9.98178 15.8958 9.22268 15.8958 8.40524C15.8958 6.37297 14.3425 4.7007 12.3595 4.51202Z"
      fill="#CD8923"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypePptxIcon;
